export default __webpack_public_path__ + "static/media/hero-punchbowl.35a4303a.webp";